import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  requestWhiteboardData,
  signalingPrivateOpenedWhiteboardsReceived,
  signalingWhiteboardDataReceived,
  signalingWhiteboardModeChanged,
  whiteboardModeChanged,
  whiteboardSettingPushed,
} from 'features/whiteboard/actions';

import { onWhiteboardDataReceivedSaga } from 'features/whiteboard/sagas/onWhiteboardDataReceivedSaga';
import { requestWhiteboardDataSaga } from 'features/whiteboard/sagas/requestWhiteboardDataSaga';
import { changeWhiteboardModeSaga } from 'features/whiteboard/sagas/changeWhiteboardModeSaga';
import { onWhiteboardModeChangedSaga } from 'features/whiteboard/sagas/onWhiteboardModeChangedSaga';
import { onPrivateOpenedWhiteboardsReceivedSaga } from 'features/whiteboard/sagas/onPrivateOpenedWhiteboardsReceivedSaga';
import { pushWhiteboardSettingSaga } from 'features/whiteboard/sagas/pushWhiteboardSettingSaga';
import { userRenamed } from 'features/users/actions';
import { onUserRenamedSaga } from 'features/whiteboard/sagas/onUserRenamedSaga';
import { userNameDecrypted } from 'features/e2ee/actions';
import { onUserNameDecryptedSaga } from 'features/whiteboard/sagas/onUserNameDecryptedSaga';
import { previewFileClosed } from 'features/content-library/contentLibrarySlice';
import { onPreviewClosedSaga } from 'features/whiteboard/sagas/onPreviewClosedSaga';
import { roomJoined } from 'features/room/roomSlice';
import { initWhiteboardDraftsSaga } from 'features/whiteboard/drafts/sagas/initWhiteboardDraftsSaga';
import { restoreWhiteboardRequested } from 'features/whiteboard/drafts/actions';
import { restoreWhiteboardSaga } from 'features/whiteboard/drafts/sagas/restoreWhiteboardSaga';

export default function* whiteboardWatcher() {
  yield takeEvery(roomJoined, initWhiteboardDraftsSaga);
  yield takeLatest(restoreWhiteboardRequested, restoreWhiteboardSaga);

  yield takeEvery(signalingWhiteboardDataReceived, onWhiteboardDataReceivedSaga);
  yield takeEvery(requestWhiteboardData, requestWhiteboardDataSaga);
  yield takeEvery(whiteboardModeChanged, changeWhiteboardModeSaga);
  yield takeEvery(signalingWhiteboardModeChanged, onWhiteboardModeChangedSaga);
  yield takeEvery(
    signalingPrivateOpenedWhiteboardsReceived,
    onPrivateOpenedWhiteboardsReceivedSaga
  );
  yield takeEvery(whiteboardSettingPushed, pushWhiteboardSettingSaga);

  yield takeEvery(userRenamed, onUserRenamedSaga);
  yield takeEvery(userNameDecrypted, onUserNameDecryptedSaga);
  yield takeEvery(previewFileClosed, onPreviewClosedSaga);
}
